<div class="delete-account-modal">
  <div class="modal-header">
    <h2 mat-dialog-title>{{ 'modals.deleteAccount.title' | transloco }}</h2>
    <i class="fas fa-exclamation-triangle warning-icon"></i>
  </div>

  <mat-dialog-content class="modal-content">
    <!-- Warning Section -->
    <div class="warning-section">
      <p class="warning-text">
        {{ 'modals.deleteAccount.warning' | transloco }}
      </p>
      <p class="irreversible-text">
        {{ 'modals.deleteAccount.irreversible' | transloco }}
      </p>
    </div>

    <!-- Processing Information Section -->
    <div class="processing-info-section">
      <h3>{{ 'modals.deleteAccount.processingInfo.title' | transloco }}</h3>
      <div class="processing-details">
        <div class="processing-item">
          <i class="fas fa-clock"></i>
          <span>{{ 'modals.deleteAccount.processingInfo.period' | transloco }}</span>
        </div>
        <div class="processing-item">
          <i class="fas fa-times-circle"></i>
          <span>{{ 'modals.deleteAccount.processingInfo.cancellation' | transloco }}</span>
        </div>
        <div class="processing-item">
          <i class="fas fa-trash"></i>
          <span>{{ 'modals.deleteAccount.processingInfo.finalDeletion' | transloco }}</span>
        </div>
      </div>
    </div>

    <!-- Data Deletion Information -->
    <div class="data-info-section">
      <h3>{{ 'modals.deleteAccount.dataInfo.title' | transloco }}</h3>

      <div class="mb-2">
        <h4>{{ 'modals.deleteAccount.dataInfo.deletedAfter30Days' | transloco }}</h4>
        <ul>
          <li>{{ 'modals.deleteAccount.dataInfo.deletedAfter30DaysItems.personalInfo' | transloco }}</li>
          <li>{{ 'modals.deleteAccount.dataInfo.deletedAfter30DaysItems.cvAttachments' | transloco }}</li>
          <li>{{ 'modals.deleteAccount.dataInfo.deletedAfter30DaysItems.notesRatings' | transloco }}</li>
          <li>{{ 'modals.deleteAccount.dataInfo.deletedAfter30DaysItems.profileData' | transloco }}</li>
        </ul>
      </div>

      <div class="retained-data">
        <h4>{{ 'modals.deleteAccount.dataInfo.retainedPseudonymized' | transloco }}</h4>
        <ul>
          <li>{{ 'modals.deleteAccount.dataInfo.retainedItems.applicationData' | transloco }} ({{ 'modals.deleteAccount.dataInfo.retainedItems.period12months' | transloco }})</li>
          <li>{{ 'modals.deleteAccount.dataInfo.retainedItems.auditLogs' | transloco }} ({{ 'modals.deleteAccount.dataInfo.retainedItems.period12months' | transloco }})</li>
          <li>{{ 'modals.deleteAccount.dataInfo.retainedItems.consentRecords' | transloco }} ({{ 'modals.deleteAccount.dataInfo.retainedItems.period24months' | transloco }})</li>
          <li>{{ 'modals.deleteAccount.dataInfo.retainedItems.technicalLogs' | transloco }} ({{ 'modals.deleteAccount.dataInfo.retainedItems.period6months' | transloco }})</li>
        </ul>
      </div>
    </div>

    <!-- Reason Section (Optional) -->
    <div class="reason-section">
      <label>{{ 'modals.deleteAccount.reason.label' | transloco }}</label>
      <textarea
        [(ngModel)]="reason"
        [placeholder]="'modals.deleteAccount.reason.placeholder' | transloco"
        rows="3"
        class="reason-textarea">
      </textarea>
      <p class="hint">{{ 'modals.deleteAccount.reason.hint' | transloco }}</p>
    </div>


    <!-- Confirmation Text -->
    <div class="confirmation-section">
      <p>{{ 'modals.deleteAccount.confirmation.instruction' | transloco }}</p>
      <app-input
        [label]="'modals.deleteAccount.confirmation.label' | transloco"
        placeholder="DELETE"
        [(ngModel)]="confirmationText"
        [required]="true">
      </app-input>
      <div class="validation-indicator" [class.valid]="isConfirmationValid">
        <i class="fas" [ngClass]="isConfirmationValid ? 'fa-check-circle' : 'fa-times-circle'"></i>
        <span>
          {{ isConfirmationValid ?
             ('modals.deleteAccount.confirmation.valid' | transloco) :
             ('modals.deleteAccount.confirmation.invalid' | transloco) }}
        </span>
      </div>
    </div>

    <!-- Final Confirmation Checkbox -->
    <div class="final-confirmation">
      <mat-checkbox [(ngModel)]="finalConfirmation">
        {{ 'modals.deleteAccount.finalConfirmation' | transloco }}
      </mat-checkbox>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <button mat-button (click)="onCancel()">
      {{ 'common.cancel' | transloco }}
    </button>
    <button
      mat-raised-button
      color="warn"
      (click)="onConfirm()"
      [disabled]="!canSubmit">
      {{ 'modals.deleteAccount.deleteButton' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
